module.exports = __webpack_public_path__ + "media/public/img/tripadvisor-favicon-01-09af19647f5b44078cb4c84488cc4fb0.svg";